<template>
  <!-- <div ref="chart" class="mapCls"></div> -->

  <div ref="chart" :style="{ height: '100%'}"></div>
</template>

<script>
import { MapDrillDown ,vvv} from './js/echartMapOptions.js'
import { findAllAndCount } from '../../../../api/home.js'
export default {
  name: 'echartMapShow',
  async mounted() {
    new MapDrillDown(this.$refs.chart, this).init()
  }
}
</script>

<style scoped>
.mapCls {
  /* width: 100%; */
  /* height: 1000px; */
  /* background-image: url(./bg.png); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
